import script from "./IfcTreeNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./IfcTreeNode.vue?vue&type=script&setup=true&lang=ts"

import "./IfcTreeNode.vue?vue&type=style&index=0&id=32e6099e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e6099e"]])

export default __exports__